var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUserCheck = function SvgUserCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.775 0.750002C12.775 0.418631 13.0437 0.150002 13.375 0.150002H16.5C16.8314 0.150002 17.1 0.418631 17.1 0.750002V3.875C17.1 4.20637 16.8314 4.475 16.5 4.475C16.1687 4.475 15.9 4.20637 15.9 3.875V1.35H13.375C13.0437 1.35 12.775 1.08137 12.775 0.750002Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50002 9.525C1.8314 9.525 2.10002 9.79363 2.10002 10.125V12.65H4.62502C4.9564 12.65 5.22502 12.9186 5.22502 13.25C5.22502 13.5814 4.9564 13.85 4.62502 13.85H1.50002C1.16865 13.85 0.900024 13.5814 0.900024 13.25V10.125C0.900024 9.79363 1.16865 9.525 1.50002 9.525Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 9.525C16.8314 9.525 17.1 9.79363 17.1 10.125V13.25C17.1 13.5814 16.8314 13.85 16.5 13.85H13.375C13.0437 13.85 12.775 13.5814 12.775 13.25C12.775 12.9186 13.0437 12.65 13.375 12.65H15.9V10.125C15.9 9.79363 16.1687 9.525 16.5 9.525Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.900024 0.750002C0.900024 0.418631 1.16865 0.150002 1.50002 0.150002H4.62502C4.9564 0.150002 5.22502 0.418631 5.22502 0.750002C5.22502 1.08137 4.9564 1.35 4.62502 1.35H2.10002V3.875C2.10002 4.20637 1.8314 4.475 1.50002 4.475C1.16865 4.475 0.900024 4.20637 0.900024 3.875V0.750002Z",
    fill: "#666666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25002 3.275C5.5814 3.275 5.85002 3.54363 5.85002 3.875V10.125C5.85002 10.4564 5.5814 10.725 5.25002 10.725C4.91865 10.725 4.65002 10.4564 4.65002 10.125V3.875C4.65002 3.54363 4.91865 3.275 5.25002 3.275Z",
    fill: "#666666"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 3.275C13.0814 3.275 13.35 3.54363 13.35 3.875V10.125C13.35 10.4564 13.0814 10.725 12.75 10.725C12.4187 10.725 12.15 10.4564 12.15 10.125V3.875C12.15 3.54363 12.4187 3.275 12.75 3.275Z",
    fill: "#666666"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 3.275C10.5814 3.275 10.85 3.54363 10.85 3.875V10.125C10.85 10.4564 10.5814 10.725 10.25 10.725C9.91865 10.725 9.65002 10.4564 9.65002 10.125V3.875C9.65002 3.54363 9.91865 3.275 10.25 3.275Z",
    fill: "#666666"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75002 3.275C8.08139 3.275 8.35002 3.54363 8.35002 3.875V10.125C8.35002 10.4564 8.08139 10.725 7.75002 10.725C7.41865 10.725 7.15002 10.4564 7.15002 10.125V3.875C7.15002 3.54363 7.41865 3.275 7.75002 3.275Z",
    fill: "#666666"
  })));
};
export default SvgUserCheck;